import Tooltip from '@mui/material/Tooltip';
import type { SxProps, Theme } from '@mui/material/styles';
import type { Channel } from '@t/productOffering.types';
import { ChannelLogo } from '@shared/components/display/ChannelLogo/ChannelLogo';
import { useChannelInfoTooltip } from '@hooks/useChannelInfoTooltip';
import { ChannelLogoWrapper, channelTooltipProps } from './TVChannelLogos.styles';
import { ChannelHoverCard } from './ChannelHoverCard';

interface ChannelLogoTooltipProps {
  channel: Channel;
  placement: 'left' | 'right' | 'top';
  logoWidth?: number | string;
  logoHeight?: number | string;
  logoPadding?: string;
  logoBorderRadius?: string;
  wrapperSx?: SxProps<Theme>;
}

/**
 * One channel logo with its info-card Tooltip. Lives in its own component so the
 * controlled-tooltip hook is called once per logo (a hook can't run inside the
 * parent's .map loop). On a fine pointer the hook is a passthrough, so the
 * Tooltip keeps its existing hover/focus behaviour.
 */
export const ChannelLogoTooltip = ({
  channel,
  placement,
  logoWidth,
  logoHeight,
  logoPadding,
  logoBorderRadius,
  wrapperSx,
}: ChannelLogoTooltipProps) => {
  const { tooltipProps, onTriggerTap } = useChannelInfoTooltip();

  return (
    <Tooltip
      title={<ChannelHoverCard channel={channel} />}
      placement={placement}
      componentsProps={channelTooltipProps}
      {...tooltipProps}
    >
      <ChannelLogoWrapper
        logoWidth={logoWidth}
        logoHeight={logoHeight}
        logoPadding={logoPadding}
        logoBorderRadius={logoBorderRadius}
        sx={wrapperSx}
        onClick={onTriggerTap}
      >
        <ChannelLogo src={channel.logo} name={channel.name} />
      </ChannelLogoWrapper>
    </Tooltip>
  );
};
